const TRANSITION_DURATION_MS = 250;
const backdropCls = "vyjb69ttku";
const wrapperCls = "vyjw1jpxvcm";
const listCls = "vyjl1f4xepu";
const noResultsWrapperCls = "vyjn11ow024";
const headingCls = "vyjhbvl55";
const noResultsHeadingCls = "vyjn1q43nnv";
const noResultsListCls = "vyjn80ogdw";
const noResultsItemCls = "vyjn17dxita";

export { TRANSITION_DURATION_MS, backdropCls, headingCls, listCls, noResultsHeadingCls, noResultsItemCls, noResultsListCls, noResultsWrapperCls, wrapperCls };
import "./molecule.result-list.style.linaria.module.css";
//# sourceMappingURL=molecule.result-list.style.js.map
